// extracted by mini-css-extract-plugin
export var divider = "_ye-0";